import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'urlFileStorage' })
export class UrlFileStoragePipe implements PipeTransform {
  transform(fileId: string): string {
    return `${fileId}`;
  }
}
